module.exports = __webpack_public_path__ + "img/alisi-firststep-icon.svg";